// import httpClient from '@src/services/http.service'

export const state = {
  EUR_TO_CZK_RATE: null
}

export const getters = {
  EUR_TO_CZK_RATE: state => state.EUR_TO_CZK_RATE
}

export const mutations = {
  SET_RATE: (state, rate) => {
    state.EUR_TO_CZK_RATE = rate
  }
}

export const actions = {
  init: ({commit}) => {
    commit('SET_RATE', 26.09) // :TODO add field to cms
    // httpClient.get('https://api.exchangeratesapi.io/latest').then(({ data }) => {
    //   commit('SET_RATE', data.rates.CZK)
    // }).catch(err => {
    //   console.error('Error while fetching currency: ', err)
    // })
  }
}
